import config from "../config";

export const UpdateRequest = async (payload) => {
  const requestOptions = {
    headers: {
      Authorization: config.keyApi,
    },
    method: "POST",
    body: JSON.stringify({
      accessToken: payload.accessToken,
      value: payload.value,
      idRichiesta: payload.idRichiesta,
      idPresenza: payload.idPresenza,
      dipendenteMail: payload.dipendenteMail,
      dipendente: payload.dipendente,
      type: payload.type,
    }),
  };

  const response = await fetch(config.apiUrl + "calendar/UpdateRequest.php", requestOptions);
  return await response.json();
};
